"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var is_server_1 = __importDefault(require("./is-server"));

exports.isExperienceEditorActive = function () {
  if (is_server_1.default()) {
    return false;
  } // eslint-disable-next-line


  var sc = window.Sitecore;
  return Boolean(sc && sc.PageModes && sc.PageModes.ChromeManager);
};

exports.resetExperienceEditorChromes = function () {
  if (exports.isExperienceEditorActive()) {
    // eslint-disable-next-line
    window.Sitecore.PageModes.ChromeManager.resetChromes();
  }
};